<div>
  <dx-lookup #artifactLookup
    appFieldsetSupport
    (inheritedDisabledChange)="isDisabled = $event"
    [dataSource]="artifactDataSource"
    [disabled]="isDisabled"
    [showClearButton]="true"
    [value]="selectedArtifact"
    (onValueChanged)="artifactSelectedInternal($event)"
    [displayExpr]="displayExpr">
    <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>

    <div *dxTemplate="let artifact of 'item'">
      <div class="the-grid">
        <div><h3>{{artifact.Name}}</h3></div>
        <div><p>Description:</p></div>
        <div><p>{{artifact.Description}}</p></div>
        <div><p>Filename:</p></div>
        <div><p class="italic">{{artifact.Filename}}</p></div>
      </div>
    </div>
  </dx-lookup>
</div>
@if (loadingArtifactDetails) {
  <span>
    <img src="../../images/ajax-loader.gif" alt="Loading artifact details..." /> Loading artifact details...
  </span>
}
